module.exports = __webpack_public_path__ + "img/icomoon.d92ae1b.svg";


//////////////////
// WEBPACK FOOTER
// ./public/pages/index/assets/css/fonts/icomoon.svg?reb7wy
// module id = 208
// module chunks = 0